import axios from '../utils/axios';
import Constants from './types';
import { getSessionId, getPayloadFromError } from '../utils';

export const getBlockingConfiguration = entityId => {
  const sessionId = getSessionId();
  return dispatch => {
    dispatch(getBlockingConfigRequest());
    axios({
      method: 'get',
      url: '/openempi-ws-rest/1.0/blocking-configuration',
      headers: {
        Accept: 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      params: {
        entityId
      }
    })
      .then(res => {
        dispatch(getBlockingConfigSuccess(res.data));
      })
      .catch(err => {
        dispatch(getBlockingConfigFailure(err));
      });
  };
};

export const saveBlockingConfiguration = blockingConfig => {
  const sessionId = getSessionId();
  return dispatch => {
    axios({
      method: 'PUT',
      url: '/openempi-ws-rest/1.0/blocking-configuration',
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      data: blockingConfig,
      params: {
        entityId: blockingConfig.entityVersionId
      }
    })
      .then(res => {
        dispatch(saveBlockingConfigSuccess(res.data));
      })
      .catch(err => {
        dispatch(saveBlockingConfigFailure(err));
      });
  };
};

export const replaceBlockingConfiguration = (entityId, sourceEntityId) => {
  const sessionId = getSessionId();
  return dispatch => {
    axios({
      method: 'PUT',
      url: '/openempi-ws-rest/1.0/blocking-configuration/replace',
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      params: {
        entityId: entityId,
        sourceEntityId: sourceEntityId
      }
    })
      .then(res => {
        dispatch(replaceBlockingConfigSuccess(res.data));
      })
      .catch(err => {
        dispatch(replaceBlockingConfigFailure(err));
      });
  };
};

export const rebuildBlockingIndexes = (entityVersionId, round) => {
  const sessionId = getSessionId();
  const parameters =
    typeof round !== 'undefined' && round >= 0
      ? { entityId: entityVersionId, blockingRoundIndex: round }
      : { entityId: entityVersionId };
  return dispatch => {
    axios({
      method: 'PUT',
      url: '/openempi-ws-rest/1.0/blocking-configuration/indexes',
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      params: parameters
    })
      .then(res => {
        dispatch(rebuildBlockingIndexesSuccess(res.data));
      })
      .catch(err => {
        dispatch(rebuildBlockingIndexesFailure(err));
      });
  };
};

const getBlockingConfigRequest = () => {
  return {
    type: Constants.BLOCKINGCONFIG_GET_REQUEST
  };
};

const getBlockingConfigSuccess = data => {
  return {
    type: Constants.BLOCKINGCONFIG_GET_SUCCESS,
    payload: data
  };
};

const getBlockingConfigFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.BLOCKINGCONFIG_GET_FAILURE,
    payload
  };
};

const saveBlockingConfigSuccess = data => {
  return {
    type: Constants.BLOCKINGCONFIG_SAVE_SUCCESS,
    payload: data
  };
};

const saveBlockingConfigFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.BLOCKINGCONFIG_SAVE_FAILURE,
    payload
  };
};

const rebuildBlockingIndexesSuccess = data => {
  return {
    type: Constants.BLOCKINGCONFIG_REINDEX_SUCCESS,
    payload: data
  };
};

const rebuildBlockingIndexesFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.BLOCKINGCONFIG_REINDEX_FAILURE,
    payload
  };
};

const replaceBlockingConfigSuccess = data => {
  return {
    type: Constants.BLOCKINGCONFIG_REPLACE_SUCCESS,
    payload: data
  };
};

const replaceBlockingConfigFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.BLOCKINGCONFIG_REINDEX_FAILURE,
    payload
  };
};

export const clearBlockingConfigError = () => {
  return {
    type: Constants.BLOCKINGCONFIG_CLEAR_ERROR
  };
};
